import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ChannelGroup } from 'icreate/common/models/channel-group';
import { BehaviorSubject, lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ChannelGroupService {
    private domain: string;
    private listSubject = new BehaviorSubject<ChannelGroup[]>([]);

    public list$ = this.listSubject.asObservable();

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    public setList(channelGroupList: ChannelGroup[]) {
        this.listSubject.next(channelGroupList);
    }

    public async getList(vesselId: string): Promise<ChannelGroup[]> {
        try {
            const channelGroupList = await lastValueFrom(
                this.http.get<ChannelGroup[]>(`${this.domain}/api/channel-groups`, {
                    params: {
                        vesselId,
                    },
                })
            );
            this.setList(channelGroupList);
            return channelGroupList;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    public async add(channelGroup: ChannelGroup, vesselId: string) {
        try {
            const newGroup = await lastValueFrom(
                this.http.post<ChannelGroup>(`${this.domain}/api/channel-groups`, {
                    channelGroup: channelGroup,
                })
            );
            await this.getList(vesselId);
            return newGroup;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    public async update(channelGroup: ChannelGroup, vesselId: string) {
        try {
            await lastValueFrom(
                this.http.put<any>(`${this.domain}/api/channel-group`, {
                    params: channelGroup,
                })
            );
            await this.getList(vesselId);
        } catch (error) {
            console.log(error);
        }
    }

    public async delete(channelGroupId: string, vesselId: string) {
        try {
            await lastValueFrom(this.http.delete(`${this.domain}/api/channel-group/${channelGroupId}`));
            await this.getList(vesselId);
        } catch (error) {
            console.log(error);
        }
    }
}
